import { BadgeSlotProps, IconSlotProps } from '../types'
import { ColorEnum } from '@/constants/color'
import { FontEnum } from '@/constants/font'
import { ComponentType, FC } from 'react'
import { StyleSheet, Text, TouchableOpacity } from 'react-native'

interface TileMenuItemProps {
    Icon: ComponentType<IconSlotProps>
    label: string
    onPress: () => void
    Badge?: ComponentType<BadgeSlotProps>
    color?: ColorEnum
}

const TileMenuItem: FC<TileMenuItemProps> = ({
    Icon,
    label,
    onPress,
    Badge,
    color = ColorEnum.BRICK_600,
}) => {
    return (
        <TouchableOpacity
            accessibilityRole="button"
            activeOpacity={0.75}
            style={[styles.container, { backgroundColor: color }]}
            onPress={onPress}
        >
            <Icon size={48} />
            <Text style={styles.label}>{label}</Text>
            {Badge && (
                <Badge active style={styles.badge} textStyle={[styles.badgeText]} color={color} />
            )}
        </TouchableOpacity>
    )
}

const styles = StyleSheet.create({
    container: {
        alignItems: 'center',
        justifyContent: 'center',
        height: 128,
        width: 128,
        gap: 8,
        borderRadius: 16,
    },
    label: {
        color: ColorEnum.WHITE,
        fontFamily: FontEnum.SatoshiBold,
        fontSize: 14,
        letterSpacing: 0.7,
        textTransform: 'uppercase',
    },
    badge: {
        position: 'absolute',
        top: 8,
        right: 8,
        minWidth: 24,
        height: 24,
    },
    badgeText: {
        fontSize: 14,
    },
})

export default TileMenuItem
